"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _default(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      rotate = _ref.rotate,
      className = _ref.className,
      _ref$dataTestid = _ref['data-testid'],
      dataTestId = _ref$dataTestid === void 0 ? 'icon' : _ref$dataTestid;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " icon icon--navigation fill-").concat(color),
    style: {
      width: "".concat(width, "px"),
      transform: "rotate(".concat(rotate, "deg)"),
      height: "".concat(height, "px")
    },
    viewBox: "0 0 24 24",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.645 4.419c-.474-.559-1.24-.559-1.713 0L8.355 10.99c-.473.558-.473 1.46 0 2.018l5.577 6.572c.473.559 1.239.559 1.713 0 .474-.558.474-1.46 0-2.019l-4.714-5.57 4.714-5.554c.474-.559.461-1.475 0-2.02z"
  }));
}